/**
 * White paper page behaviour.
 *
 * Citation superscripts link to entries inside a collapsed <details>. Browser
 * support for auto-expanding details on fragment navigation is uneven, so we
 * open any collapsed ancestor ourselves and then scroll the target into view.
 */
(function () {
  'use strict';

  function revealTarget(hash) {
    if (!hash || hash.length < 2) return;

    var target;
    try {
      target = document.querySelector(hash);
    } catch (e) {
      return;
    }
    if (!target) return;

    var opened = false;
    var node = target.parentElement;
    while (node) {
      if (node.tagName === 'DETAILS' && !node.open) {
        node.open = true;
        opened = true;
      }
      node = node.parentElement;
    }

    // Only re-scroll when we changed layout by expanding something; otherwise
    // the browser's own fragment scroll is already correct.
    if (opened) {
      target.scrollIntoView({ block: 'center' });
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link) return;

    var hash = link.getAttribute('href');
    if (hash === '#') return;

    // Collapse the sticky mobile table of contents once a destination is picked.
    var toc = link.closest('.wp-toc__card');
    if (toc) toc.open = false;

    // Let the browser update the URL, then reveal on the next frame.
    requestAnimationFrame(function () {
      revealTarget(hash);
    });
  });

  // Keep the sticky table of contents docked to the site header: track the
  // header's live position so the TOC pins directly beneath it and rides up to
  // the viewport top when the header hides on scroll-down (no empty strip). A
  // `wp-toc--pinned` flag drives the backdrop that hides content behind it.
  function watchTocPin() {
    var toc = document.querySelector('.wp-toc');
    var wrapper = toc && toc.closest('.section-landing-toc');
    if (!toc || !wrapper) return;

    var header = document.querySelector('.section-header');
    var headerVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var headerHeight = parseInt(headerVar, 10) || 56;
    var ticking = false;

    function update() {
      ticking = false;
      // The header slides between fully shown and fully hidden; its visible
      // bottom edge is where the TOC should dock.
      var dock = header ? Math.max(0, header.getBoundingClientRect().bottom) : headerHeight;
      wrapper.style.setProperty('--wp-toc-top', dock + 'px');
      toc.classList.toggle('wp-toc--pinned', wrapper.getBoundingClientRect().top <= dock + 0.5);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // The header animates its slide, so re-dock when that transition settles.
    if (header) header.addEventListener('transitionend', update);
  }

  watchTocPin();

  window.addEventListener('hashchange', function () {
    revealTarget(window.location.hash);
  });

  if (window.location.hash) {
    revealTarget(window.location.hash);
  }
})();
